module.exports = __webpack_public_path__ + "static/media/randomQuoteMachine.461a40a0.png";